<t4-container title=""  [isLoading]="isLoading">
  <div class="mapContainer">
    <div class="sliderContainer" style="padding: 5px;">
      <div>
        <span>{{ 'Turbo.RentalObject.Map.lblHistory' | translate : 'History'}}: </span><b class="gridSizeValue"></b>
        <mat-slider min="0" [max]="mapHistory.length - 1">
          <input matSliderThumb [(ngModel)]="selectedHistoryIndex" (ngModelChange)="updateSetting($event)" />
        </mat-slider>
        <button mat-button (click)="updateHistory(-1)">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button mat-button (click)="updateHistory(1)">
          <mat-icon>chevron_right</mat-icon>
        </button>

        <mat-form-field appearance="outline" style="position:absolute; right:10px; margin:auto; max-width:250px;">
          <mat-label>Search on date</mat-label>
          <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" (dateChange)="searchOnDate()">
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

      </div>
   
      <p *ngIf="mapHistory.length">
        {{ 'Turbo.RentalObject.Map.lblDate' | translate : 'Date'}}: {{ mapHistory[selectedHistoryIndex]?.Created | date:'short' }}
      </p>
    </div>
    <div #gmap style="height: calc(100vh - 900px); min-height: 300px; width: 100%;"></div>
    <!--<div class="mapFunctions">
      <div class="mapFilterBox">
        <mat-form-field>
          <input #txtMapSearch matInput placeholder="{{ 'Turbo.RentalObject.Map.lblLocationSearch' | translate : 'Find location'}}" type="text" />
        </mat-form-field>
      </div>
    </div>-->
  </div>
</t4-container>
